/*
 * This file contains the env variables defined by the user here, to get access to properties
 * in a simple way by importing the EnvConfigConst file
 */
export default {
    ROOM_CATEGORY_ENABLED: false,
    ROOM_TYPE_EXCEPTIONS: process.env.REACT_APP_ROOM_TYPE_MAX_EXCEPTIONS,
}